import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setAddressDropDownList } from 'Store/Organization/AutoCompleteAddressSearch/AddressSearchAction';
import { GET_ADDRESS_DROPDOWN_LIST } from 'Store/Organization/AutoCompleteAddressSearch/AddressSearchType';
import { apiMethod, apiType, API_URL } from 'utils';
import OrganizationApiService from './OrganizationApiService';
import { IPayload } from 'Model/IPayload';


function* getAddressDropDownListSaga(payload:any): any {
    let payloadData : IPayload = {                
        apiMethod : apiMethod.GET,
        apiType : apiType.Organization,
        endpoint : `organizations/address/autocomplete?addressKeyword=${payload?.state}`,
        payload : null
    }
    try {
        yield put(globalLoaderText("Fetching Data...."));

        const response = yield call(
            OrganizationApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setAddressDropDownList(response, payload?.target));
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* watchGetAddress() {
    yield takeEvery(GET_ADDRESS_DROPDOWN_LIST, getAddressDropDownListSaga)
}

export default function* combinedSaga() {
    yield all([
        watchGetAddress()
    ])
}
